import http from '../../utils/fetch';
import updownfile from "../../utils/updownfile";

export default {
    baseurl: '/api/swyl/v1/viewOrderProcess',
    // 手动发货过账
    clickfhgzadd3list(params){
        return http({
            url: '/api/swyl/v1/dingd/bsc/OrderCg/fahuoguozhang',
            method: 'post',
            params: params
        });
    },
    // 物流，sap，发货
    sapcodelistSendclick(params){
        return http({
            url: '/api/swyl/v1/dingdmainsend/sapcodelistSendclick',
            method: 'post',
            params: params
        });
    },
    searchSapKucunshuliang(orders){
        return http({
            url: '/api/swyl/v1/sapkucun/searchSapKucunshuliang',
            method: 'post',
            params: {orders:orders}
        });
    },
    tongbuSapKucunshuliang(kuwei){
        return http({
            url: '/api/swyl/v1/sapkucun/tongbuSapKucunshuliang',
            method: 'post',
            params: {kuwei:kuwei}
        });
    },
    //从sap查询并更新单个订单
    getSingleOrderStatus(sapId) {
        return http.post(this.baseurl + '/getSingleOrderStatus?sapId='+sapId);
    },
    zuofeiSapBtn(sapid){
        return http({
            url: '/api/swyl/v1/ddzfcc/zuofeiSap',
            method: 'post',
            params: {sapId:sapid}
        });
    },
    zuofeiSapCgddhBtn(id){
        return http({
            url: '/api/swyl/v1/dingd/bsc/OrderCg/glychehuiCgOrder',
            method: 'post',
            params: {id:id}
        });
    },
    //创建新订单
    sendToSapByYourself(entity) {
        return http({
                    url: this.baseurl + '/sendToSapByYourself',
                    method: 'post',
                    params: entity
                });
    },
    //更新异地发货
    getShifouyidi(){
        return http.post(this.baseurl + '/getShifouyidi');
    },



    //通过用户id查询其所有项目详情
    projectManagePage1(query) {
        return http({
            url: '/api/swyl/v1/xiangmu/proMain/projectManagePage1',
            method: 'post',
            params: query
        });
    },

    //通过用户id查询其所有项目详情(项目去重)
    projectManagePageG(query) {
        return http({
            url: '/api/swyl/v1/xiangmu/proMain/projectManagePageG',
            method: 'post',
            params: query
        });
    },




    // //创建新订单
    // createNewOrder(query) {
    //     return http.post(this.baseurl + '/order/createNewOrder', query);
    // },
    // //通过订单id获取订单详情
    // getDetails(query) {
    //     return http({
    //         url: this.baseurl + '/order/getOrderDetailByOrderId',
    //         method: 'post',
    //         params: query
    //     });
    // },
    // //
    // selectPage(query) {
    //     return http({
    //         url: this.baseurl + '/order/selectPage',
    //         method: 'post',
    //         params: query
    //     });
    // },
    //
    // //自行添加一行产品信息
    // getSingleOrder(x) {
    //     return http.post(this.baseurl + '/order/getSingleOrder?productId=' + x.materialCode)
    // },
    //
    // //订单详情查看
    // getSingleOrderDetail(query) {
    //     return http.post(this.baseurl + '/order/getSingleOrderDetail?id=' + query.orderId)
    // },
    //
    // getFilteredProductPage(query) {
    //     return http({
    //         url: '/api/swyl/v1/xiangmu/proProductInfo/getFilteredProductPage?projectId=' + query.id,
    //         method: 'post',
    //         params: query
    //     });
    // },
    //
    // //获取用户所有预测
    // getYuCe(query) {
    //     return http({
    //         url: '/api/swyl/v1/demo/bscForecastForeDetail/showPlan?cucode=' + query.id,
    //         method: 'post',
    //         params: query
    //     });
    // },
    //
    // //特价产品数量扣除
    // useTJ(query){
    //     http.post('/api/swyl/v1/manager/SpecialController/getbyformula',query);
    // },
    // //用户所有订单产品详情
    // getOrderProByUserIdPage(query) {
    //     return http({
    //         url: this.baseurl + '/order/getOrderProByUserIdPage',
    //         method: 'post',
    //         params: query
    //     });
    // },
    // //用户所有信贷详情
    // getCredit(query) {
    //     return http({
    //         url: this.baseurl + '/order/getCredit',
    //         method: 'post',
    //         data: query
    //     });
    // },
    //
    // //用户及其子用户所有订单产品详情
    // getAllOrderProByUserIdPage(query) {
    //     return http({
    //         url: this.baseurl + '/order/getAllOrderProByUserIdPage',
    //         method: 'post',
    //         params: query
    //     });
    // },
    //
    // //用户及其子用户所有订单产品详情
    // jiansuoQuery(query) {
    //     return http({
    //         url: this.baseurl + '/order/jiansuoQueryPage',
    //         method: 'post',
    //         params: query
    //     });
    // },
    //
    // //订单审批接口
    // orderPass(query) {
    //     return http({
    //         url: this.baseurl + '/order/orderPass',
    //         method: 'post',
    //         params: query
    //     });
    // },
    //
    // //删除产品
    // deleteByIdLogi(id) {
    //     return http.post(this.baseurl + '/order/deleteByIdLogi?id=' + id)
    // },
    // //订单作废
    // sapDeleteOrder(query) {
    //         return http({
    //             url: this.baseurl + '/order/sapDeleteOrder',
    //             method: 'post',
    //             params: query
    //         });
    //     },
    // //通过用户id查询其所有项目详情
    // projectManagePage() {
    //     return http.post('/api/swyl/v1/xiangmu/proMain/projectManagePage')
    // },

    // //根据用户id查询其项目所有库存信息并储存
    // getOrderStock() {
    //     return http.post(this.baseurl + '/order/getOrderStock')
    // },
    // //导出订单列表Excel
    // getOrderExcel(query) {
    //     updownfile.down(this.baseurl + '/order/getOrderExcel', query, "post", 'data');
    // },
    //
    // //用户现金及信贷额度查询
    // queryMoney(x) {
    //     return http.post('/api/swyl/v1/totalmoney/bscUserTotalmoney/selectByUserCode?userCode=' + x);
    // },
    // //根据订单实体类查询现金及信贷额度
    // queryMoneyByOrderCode(x) {
    //     return http.post('/api/swyl/v1/totalmoney/bscUserTotalmoney/selectByOrderCode?orderCode=' + x);
    // },
	//获取租赁合同
	getContractList() {
		return http.post('/api/swyl/v1/hetong/bscContract/selectZulinList');
    },
    //获取外销租赁合同
    nwSaleListContract(data) {
        return http.post('/api/swyl/v1/hetong/bscContract/nwSaleListContract', data);
    },
    // toshow(pageId,nextShow){
    //     return http({
    //         url: '/api/swyl/v1/demo/bscNoviceGuideDetail/isShowNoviceGuide',
    //         method: 'post',
    //         params: {pageId,nextShow}
    //     });
    // },

    //记录订单otd
    getOrderMianOtdList(query) {
        return http({
            url: '/api/swyl/v1/demo/bscOrderMainOtd/selectPage',
            method: 'post',
            params: query
        });
    },
    //售后签收确认列表
    getAfterSalesConfirmList(query) {
        return http({
            url: '/api/swyl/v1/demo/bscAfterSalesConfirm/selectPage',
            method: 'post',
            params: query
        });
    },


}
